import { gql } from '@apollo/client/core'
import DRAFT_STANDARD_CRITERION_OPTION from './draftStandardCriterionOption'

export const DRAFT_STANDARD_AUDIENCE_ITEM = gql`
  ${DRAFT_STANDARD_CRITERION_OPTION}
  fragment DraftStandardAudienceItem on DraftStandardAudienceItem {
    criterion {
      code
      name
      question {
        questionId
        text
        createdDate
        translations {
          language
          text
          textStyling
        }
      }
      createdDate
    }
    settingValues {
      code
      value
      createdDate
      sinceDate
    }
    standardCriterionOptions {
      ...DraftStandardCriterionOption
    }
    customizedCriterionOptions {
      ...DraftStandardCriterionOption
    }
  }
`
